/* ==========================================================
   HP – Drawer Menu Upgrade (Accordion behavior)
   - Keeps only one submenu open at a time (optional)
   - Smooth close on route click (optional)
   ========================================================== */

(function () {
  function initDrawer() {
    const drawer = document.querySelector('.menu-drawer');
    if (!drawer) return;

    const details = Array.from(drawer.querySelectorAll('details'));

    // Only one open at a time (main level)
    details.forEach(d => {
      d.addEventListener('toggle', () => {
        if (!d.open) return;

        // close siblings on same level
        const parent = d.parentElement;
        const siblings = Array.from(parent.querySelectorAll(':scope > details'));
        siblings.forEach(s => {
          if (s !== d) s.removeAttribute('open');
        });
      });
    });

    // Optional: close drawer when clicking a normal link
    drawer.addEventListener('click', (e) => {
      const a = e.target.closest('a');
      if (!a) return;

      // ignore links that are part of summary toggle
      if (a.closest('summary')) return;

      // If theme uses <details> for drawer open, try to close it
      const container = document.querySelector('.menu-drawer-container');
      if (container) {
        // Dawn usually toggles aria-expanded on header icon
        const btn = document.querySelector('summary.header__icon--menu');
        if (btn) btn.click();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initDrawer);
})();
